import { render, staticRenderFns } from "./type_1.vue?vue&type=template&id=b4a307b6&scoped=true"
import script from "./type_1.vue?vue&type=script&lang=js"
export * from "./type_1.vue?vue&type=script&lang=js"
import style0 from "./type_1.vue?vue&type=style&index=0&id=b4a307b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a307b6",
  null
  
)

export default component.exports